import { UploadedLocationStatus } from "../components/locations/UploadMultipleLocations";
import { DealStatus } from "../interfaces/IDeal";
import { LeadOwnershipType, LeadStatus } from "../interfaces/ILead";
import { LeaseCompPropertyType, LeaseCompSource, LeaseType } from "../interfaces/ILeaseComp";
import { SaleCompDealProfile, SaleCompPropertyType, SaleCompSource } from "../interfaces/ISaleComp";
import { CorpOwnership } from "../interfaces/ITenantInMarket";

export const leadStatusToString = (status: string): string => {
    switch (status) {
        case LeadStatus.OpenLead: return "Open Lead";
        case LeadStatus.ActiveConversations: return "Active Conversations";
        case LeadStatus.OIPass: return "OI Pass";
        case LeadStatus.SellerPass: return "Seller Pass";
        default: return "";
    }
}

export const leadOwnershipTypeToString = (ownershipType: LeadOwnershipType): string => {
    switch (ownershipType) {
        case LeadOwnershipType.Government: return "Government";
        case LeadOwnershipType.Individual: return "Individual";
        case LeadOwnershipType.Investor: return "Investor";
        case LeadOwnershipType.NonProfit: return "Non-Profit";
        case LeadOwnershipType.OtherUnclassified: return "Other / Unclassified";
        case LeadOwnershipType.ShellCompany: return "Shell Company";
        case LeadOwnershipType.Trust: return "Trust";
        case LeadOwnershipType.User: return "User";
    }
}

export const leaseTypeToString = (leaseType: LeaseType): string => leaseType === LeaseType.SeeNotes ? "See Notes" : leaseType;

export const leaseCompPropertyTypeToString = (propertyType: LeaseCompPropertyType): string => {
    switch (propertyType) {
        case LeaseCompPropertyType.IOSNoBuilding: return "IOS No Building";
        case LeaseCompPropertyType.IOSWithBuilding: return "IOS With Building";
        case LeaseCompPropertyType.SmallBay: return "Small Bay";
        case LeaseCompPropertyType.Distribution: return "Distribution";
        case LeaseCompPropertyType.SelfStorage: return "Self Storage";
        case LeaseCompPropertyType.RVBoatStorage: return "RV Boat Storage";
        case LeaseCompPropertyType.TruckTerminal: return "Truck Terminal";
        case LeaseCompPropertyType.Other: return "Other";
    }
}

export const leaseCompSourceToString = (propertyType: LeaseCompSource) => {
    switch (propertyType) {
        case LeaseCompSource.PropertyOwner: return "Property Owner";
        case LeaseCompSource.TransactionBroker: return "Transaction Broker";
        case LeaseCompSource.Tenant: return "Tenant";
        case LeaseCompSource.ThirdPartyBroker: return "Third Party Broker";
        case LeaseCompSource.Other: return "Other";
    }
}

export const saleCompPropertyTypeToString = (propertyType: SaleCompPropertyType) => {
    switch (propertyType) {
        case SaleCompPropertyType.RawLand: return "Raw Land";
        case SaleCompPropertyType.DataCenterLand: return "Data Center Land";
        case SaleCompPropertyType.DistributionDevelopmentLand: return "Distribution Development Land";
        case SaleCompPropertyType.IOSNoBuilding: return "IOS No Building";
        case SaleCompPropertyType.IOSWithBuilding: return "IOS With Building";
        case SaleCompPropertyType.SmallBay: return "Small Bay";
        case SaleCompPropertyType.Distribution: return "Distribution";
        case SaleCompPropertyType.SelfStorage: return "Self Storage";
        case SaleCompPropertyType.RVBoatStorage: return "RV Boat Storage";
        case SaleCompPropertyType.TruckTerminal: return "Truck Terminal";
        case SaleCompPropertyType.Other: return "Other";
    }
}

export const saleCompDealProfileToString = (dealProfile: SaleCompDealProfile) => {
    switch (dealProfile) {
        case SaleCompDealProfile.UserSale: return "User Sale";
        case SaleCompDealProfile.ValueAdd: return "Value-Add";
        case SaleCompDealProfile.Development: return "Development";
        case SaleCompDealProfile.Core: return "Core";
        case SaleCompDealProfile.CorePlus: return "Core+";
    }
}

export const saleCompSourceToString = (propertyType: SaleCompSource) => {
    switch (propertyType) {
        case SaleCompSource.PropertyOwner: return "Property Owner";
        case SaleCompSource.TransactionBroker: return "Transaction Broker";
        case SaleCompSource.PublicRecord: return "Public Record";
        case SaleCompSource.ThirdPartyBroker: return "Third Party Broker";
        case SaleCompSource.Costar: return "Costar";
    }
}

export const dealStatusToString = (status: DealStatus) => {
    switch (status) {
        case DealStatus.Open: return "Open";
        case DealStatus.Won: return "Won";
        case DealStatus.Lost: return "Lost";
        case DealStatus.Deleted: return "Deleted";
    }
}

export const corpOwnershipToString = (corpOwnership: CorpOwnership) => {
    switch (corpOwnership) {
        case CorpOwnership.Public: return "Public";
        case CorpOwnership.Private: return "Private";
    }
}

export const uploadedLocationStatusToString = (status: UploadedLocationStatus) => {
    switch (status) {
        case UploadedLocationStatus.AddressOrLatLonIsRequired: return "Address or Lat/Lon is required";
        case UploadedLocationStatus.Duplicate: return "Duplicate";
        case UploadedLocationStatus.PropertyNotFound: return "Property not found";
        case UploadedLocationStatus.AlreadyExist: return "Already exists";
        case UploadedLocationStatus.CanBeAdded: return "Can be added";
    }
}
